export default function TS_Basic_Generics() {
  return (
    <div>
      <h1>TS Basic Generics</h1>
      <p>This is the TS Basic Generics page.</p>
    </div>
  );
}